import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppReleaseService } from '../../../services/app-release.service';
import { CreateDesktopAppRelease } from '../../../models/inModels/app-release.model';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-create-release',
  templateUrl: './create-release.component.html'
})
export class CreateReleaseComponent {
  file: File | null = null;
  error: any[] = [];
  loading = false;
  model: CreateDesktopAppRelease;

  platforms = [
    { id: 1, label: 'Windows' },
    { id: 2, label: 'MacOS' },
    { id: 3, label: 'Linux' },
    ];

   selectedPlatformType: any = null;
   fileName: string | null = null;

  constructor(private service: AppReleaseService, public storageService: StorageService) {
    this.model = new CreateDesktopAppRelease();
  }

    onFileSelect(event: any) {
    if (event.files && event.files.length > 0) {
        this.file = event.files[0];
        this.fileName = this.file.name;  // save file name to show
    } else {
        this.fileName = null;
    }
    }

    handleFileUpload(event): void {
        var result = this.storageService.handleSuccess(event);
        this.model.PublicId = result.PublicId;
        this.model.FileName = this.fileName; 
        this.model.FileSize = result.SizeBytes;
        this.loading = false;
    }

  save() {
    if (!this.file) {
      this.error = [{ severity: 'error', summary: 'Error', detail: 'Please select a file.' }];
      return;
    }

    this.loading = true;
    this.model.Platform = this.selectedPlatformType ? this.selectedPlatformType.id : 1; // Default to Windows if not selected
    this.service.uploadDesktopRelease(this.model).then(
      res => {
        this.loading = false;
        this.goBack();
      },
      err => {
        this.error = [{ severity: 'error', summary: 'Error', detail: 'Upload failed.' }];
        this.loading = false;
      }
    );
  }

  goBack() {
    history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-release/create-release/create-release.component.ts